import React, { Fragment } from "react";

import DidMountWillUnmount from "../DidMountWillUnmount";
import MentionSpanOffsetTracker from "./MentionSpanOffsetTracker";
import PropTypes from "prop-types";

export default function MentionSpanTag({ offsetKey, children }) {
  return (
    <>
      <DidMountWillUnmount
        didMount={() => MentionSpanOffsetTracker.putOffsetKey(offsetKey)}
        willUnmount={() => MentionSpanOffsetTracker.delOffsetKey(offsetKey)}
      />

      {children}
    </>
  );
}

MentionSpanTag.propTypes = {
  offsetKey: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};
